<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>{{ $t('invoice.mainProgram') }}</label>
          <a-select v-model="apcId" mode="multiple" :loading="loading" :options="apcList" class="ts-w-full"
            @change="onMainChange(apcId)"></a-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>{{ $t('invoice.subProgram') }}</label>
          <a-select v-model="apcsId" 
            mode="multiple" :loading="loading"
            :options="subProgramOptions"
            @change="onSubProgramChange"
            class="ts-w-full"></a-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'mainProgramSelectBox',
  props: ['companyId'],
  data() {
    return {
      loading: false,
      subProgramOptions: null
    }
  },
  async created() {
    this.loading = true
    await this.getMainProgram().finally(() => (this.loading = false))
  },
  computed: {
    apcId: {
      get() {
        return this.$store.state.invoice.acp_id
      },
      set(newValue) {
        this.$store.commit('invoice/SET_APC_ID', newValue)
      }
    },
    apcsId: {
      get() {
        return this.$store.state.invoice.acps_id
      },
      set(newValue) {
        this.$store.commit('invoice/SET_APCS_ID', newValue)
      }
    },
    apcList() {
      return this.$store.state.invoice.mainPrograms
        .filter(acp => this.companyId.length ? this.companyId.includes(acp.company_id) : true)
        .map(el => ({
          value: el.acp_id,
          label: `${el.prefix ? el.prefix + ' - ' : ''}${el.acp_name_foreign}`
        }))
    }
  },
  methods: {
    ...mapActions('invoice', ['getMainProgram']),
    onMainChange(apcId) {
      if (!apcId || apcId.length === 0) {
        this.apcsId = []
        this.subProgramOptions = []
        return
      }

      this.apcsId = []
      this.subProgramOptions = []

      this.$store
        .dispatch('invoice/fetchSubProgram', { acp_id: apcId })
        .then(response => {
          this.subProgramOptions = response.data.map(el => ({
            value: el.acps_id,
            label: `${el.prefix ? el.prefix + ' - ' : ''}${el.acps_name_foreign
              }`
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      this.$emit('fetch')
    },
    onSubProgramChange() {
      this.$emit('fetch')
    }
  },
  watch: {
    companyId() {
      this.apcId = []
      this.apcsId = []
      this.subProgramOptions = []
      this.$emit('fetch')
    }
  }
}
</script>
